import {AllData} from "./model/all-data-schema";
// @ts-ignore
import woehlerschuleLogo from "../static/projects/woehlerschule/woehlerschule.png";
import hourzLogo from "../static/projects/hourz/hourz.png";
import luminaLogo from "../static/projects/lumina/lumina.png";
import cactusInterviewsLogo from "../static/projects/cactus-interviews/cactus-interviews.png";
import carimboLogo from "../static/projects/carimbo/carimbo.png";

import luminaScreenshot1 from "../static/projects/lumina/lumina-1.png";
import luminaScreenshot2 from "../static/projects/lumina/lumina-2.png";
import luminaScreenshot3 from "../static/projects/lumina/lumina-3.png";
import luminaScreenshot4 from "../static/projects/lumina/lumina-4.png";

import woehlerschuleScreenshot1 from "../static/projects/woehlerschule/woehler-1.png";
import woehlerschuleScreenshot2 from "../static/projects/woehlerschule/woehler-2.png";
import woehlerschuleScreenshot3 from "../static/projects/woehlerschule/woehler-3.png";
import woehlerschuleScreenshot4 from "../static/projects/woehlerschule/woehler-4.png";

import hourzScreenshot1 from "../static/projects/hourz/hourz-1.png";
import hourzScreenshot2 from "../static/projects/hourz/hourz-2.png";
import hourzScreenshot3 from "../static/projects/hourz/hourz-3.png";
import hourzScreenshot4 from "../static/projects/hourz/hourz-4.png";

import bruderArchitektenScreenshot1 from "../static/projects/bruder-architekten/ba-1.png";
import bruderArchitektenScreenshot2 from "../static/projects/bruder-architekten/ba-2.png";
import bruderArchitektenScreenshot3 from "../static/projects/bruder-architekten/ba-3.png";
import bruderArchitektenScreenshot4 from "../static/projects/bruder-architekten/ba-4.png";

import cactusInterviewsScreenshot1 from "../static/projects/cactus-interviews/cactus-1.png";
import cactusInterviewsScreenshot2 from "../static/projects/cactus-interviews/cactus-2.png";
import cactusInterviewsScreenshot3 from "../static/projects/cactus-interviews/cactus-3.png";
import cactusInterviewsScreenshot4 from "../static/projects/cactus-interviews/cactus-4.png";

import carimboScreenshot1 from "../static/projects/carimbo/carimbo-1.png";
import carimboScreenshot2 from "../static/projects/carimbo/carimbo-2.png";
import carimboScreenshot3 from "../static/projects/carimbo/carimbo-3.png";
import carimboScreenshot4 from "../static/projects/carimbo/carimbo-4.png";

import wwdcPicture1 from "../static/certificates/wwdc/wwdc-1.jpg";
import wwdcPicture2 from "../static/certificates/wwdc/wwdc-2.jpg";
import wwdcPicture3 from "../static/certificates/wwdc/wwdc-3.jpg";

import awsLogo from "../static/certificates/aws/aws.jpg";
import toeflLogo from "../static/certificates/toefl/toefl.png";

import fortoLogoLight from "../static/cv/forto/logo-light.png";
import fortoLogoDark from "../static/cv/forto/logo-dark.png";
import fortoScreenshot1 from "../static/cv/forto/forto-1.png";
import fortoScreenshot2 from "../static/cv/forto/forto-2.png";
import fortoScreenshot3 from "../static/cv/forto/forto-3.png";

import finnLogoLight from "../static/cv/finn/logo-light.png";
import finnLogoDark from "../static/cv/finn/logo-dark.png";
import finnScreenshot1 from "../static/cv/finn/finn-1.png";
import finnScreenshot2 from "../static/cv/finn/finn-2.png";
import finnScreenshot3 from "../static/cv/finn/finn-3.png";

import tekkrLogoLight from "../static/cv/tekkr/logo-light.png";
import tekkrLogoDark from "../static/cv/tekkr/logo-dark.png";
import tekkrScreenshot1 from "../static/cv/tekkr/tekkr-1.png";
import tekkrScreenshot2 from "../static/cv/tekkr/tekkr-2.png";
import tekkrScreenshot3 from "../static/cv/tekkr/tekkr-3.png";
import tekkrScreenshot4 from "../static/cv/tekkr/tekkr-4.png";
import tekkrScreenshot5 from "../static/cv/tekkr/tekkr-5.png";
import tekkrScreenshot6 from "../static/cv/tekkr/tekkr-6.png";
import tekkrScreenshot7 from "../static/cv/tekkr/tekkr-7.png";

import kpmgLogoLight from "../static/cv/kpmg/logo-light.png";
import kpmgLogoDark from "../static/cv/kpmg/logo-dark.png";

import uniMannheimLogoLight from "../static/cv/uni-mannheim/logo-light.png";
import uniMannheimLogoDark from "../static/cv/uni-mannheim/logo-dark.png";

import novaLogoLight from "../static/cv/nova/logo-light.png";
import novaLogoDark from "../static/cv/nova/logo-dark.png";

import savedroidLogo from "../static/cv/savedroid/logo.png";

import appleLogoLight from "../static/certificates/apple/logo-light.png";
import appleLogoDark from "../static/certificates/apple/logo-dark.png";

import gmatLogoLight from "../static/certificates/gmat/logo-light.png";
import gmatLogoDark from "../static/certificates/gmat/logo-dark.png";

import webSummitLogoLight from "../static/certificates/web-summit/logo-light.png";
import webSummitLogoDark from "../static/certificates/web-summit/logo-dark.png";


import {ProjectTypes} from "./model/project";

export const moritzData: AllData = {
    name: "Moritz Bruder",
    title: "Software Engineer",
    aboutMe: "I'm a software engineer who loves building products from scratch. I've architected full systems as a founding engineer and replaced operational backbones at scale-ups. I take ownership end-to-end, from infrastructure to UI, and regularly ship side projects. I'm equally comfortable writing code, making product decisions, and figuring out what to build next.",
    birthYear: 1998,
    links: {
        github: "https://github.com/moritzbruder",
        linkedin: "https://linkedin.com/in/moritzbruder"
    },
    cv: [
        {
            type: "work",
            company: {
                logo: {
                    light: tekkrLogoLight,
                    dark: tekkrLogoDark,
                },
                name: "Tekkr",
                websiteUrl: "https://tekkr.io",
                tooltip: "Early stage startup helping tech leaders and teams work more effectively."
            },
            location: "Berlin",
            role: "Founding Engineer",
            startDate: "2024-10-01",
            description: [
                `Built an LLM-based project planning and execution support tool for tech teams from scratch. "Cursor for project management".`,
                "Owned the entire tech side of the business: architecture, infrastructure, development, deployment, monitoring, security, etc.",
                "Designed the UI, covered a lot of the product work and hired an intern to support me.",
                "Set up an AI-driven development process using LLMs to speed up delivery.",
            ],
            media: {
                items: [tekkrScreenshot1, tekkrScreenshot2, tekkrScreenshot3, tekkrScreenshot4, tekkrScreenshot5, tekkrScreenshot6, tekkrScreenshot7],
                display: "landscape",
            },
        },
        {
            type: "work",
            company: {
                logo: {
                    light: finnLogoLight,
                    dark: finnLogoDark,
                },
                name: "FINN",
                websiteUrl: "https://finn.com",
                tooltip: "Car subscription service based in Munich, Germany."
            },
            location: "Lisbon (Remote)",
            startDate: "2022-11-01",
            endDate: "2024-09-30",
            role: "Senior Software Engineer",
            description: [
                "My team replaced the entire no-code backbone for the company's operations with a custom backend.",
                "We restructured almost all processes and interfaces with other teams and owned the automations for the entire process from car acquisition to sale.",
                "I built a service that automatically evaluates and optimizes the cost of car-to-customer allocations across the entire fleet.",
                "I built an internal tool that improved transparency by making events from across the company easily accessible.",
            ],
            media: {
                items: [finnScreenshot1, finnScreenshot2, finnScreenshot3],
                display: "landscape",
            }
        },
        {
            type: "education",
            program: "Master in Management",
            institution: {
                logo: {
                    light: novaLogoLight,
                    dark: novaLogoDark,
                },
                name: "Nova School of Business and Economics",
                websiteUrl: "https://www.novasbe.unl.pt",
                location: "Lisbon",
                tooltip: "Top business school in Portugal and one of the best in Europe.\nMiM program ranked #4 globally by Financial Times 2025."
            },
            startDate: "2021-08-01",
            endDate: "2023-01-31",
            description: "Minor in Entrepreneurship",
        },
        {
            type: "work",
            company: {
                logo: {
                    light: fortoLogoLight,
                    dark: fortoLogoDark,
                },
                name: "Forto",
                websiteUrl: "https://forto.com",
                tooltip: "Digital freight forwarder and logistics platform.",
            },
            location: "Berlin",
            startDate: "2020-09-01",
            endDate: "2021-04-30",
            role: "Product Management Intern",
            description: [
                "Built a task management solution for Forto X (Forto's integrated PO management SaaS) from scratch.",
                "With that, managed to increase data completeness from ~40% to >80%.",
                "I owned this incl. a team with 4 engineers and took over full responsibility (including stakeholder management, reporting, target setting, etc.)",
                "I also implemented userlane for user onboarding and owned several more smaller features.",
            ],
            media: {
                items: [fortoScreenshot1, fortoScreenshot2, fortoScreenshot3],
                display: "landscape",
            },
        },
        {
            type: "work",
            company: {
                logo: {
                    light: kpmgLogoLight,
                    dark: kpmgLogoDark,
                },
                name: "KPMG",
                websiteUrl: "https://kpmg.com",
                tooltip: "One of the big four auditing firms."
            },
            location: "Frankfurt am Main",
            startDate: "2018-06-01",
            endDate: "2019-07-31",
            role: "Working Student: Digital Compliance",
            description: [
                "Built automated analyses based on SAP's IS-U (used by most leading electricity companies) that generated annual reports. This also included collaboration on a data completeness analysis in collaboration with KPMG Lighthouse.",
                "I also owned a client project analysing open source license compliance.",
            ],
        },
        {
            type: "education",
            program: "B.Sc. Business Informatics",
            institution: {
                name: "University of Mannheim",
                tooltip: "Highest-ranking public business university in Germany",
                logo: {
                    light: uniMannheimLogoLight,
                    dark: uniMannheimLogoDark,
                },
                websiteUrl: "https://www.uni-mannheim.de",
                location: "Mannheim",
            },
            startDate: "2017-09-01",
            endDate: "2020-12-31",
            description: "• Exchange semester at CityU of Hong Kong in 2019\n• Teaching assistant at the chair of business informatics",
        },
        {
            type: "work",
            company: {
                logo: savedroidLogo,
                name: "savedroid",
                websiteUrl: "https://www.savedroid.de/",
                tooltip: "Savedroid was building an app for personal savings and later ventured into crypto investing before shutting down in 2019."
            },
            location: "Frankfurt am Main",
            endDate: "2017-08-31",
            role: "iOS Development Intern",
            startDate: "2017-02-01",
            description: [
                "I was one of two iOS developers and built several features for the app including new screens for viewing transactions, a credit card page, and new savings automations.",
                "In a second stint at the company in 2018 I also supported backend development and customer support for the company's ICO."
            ]
        }
    ],
    projects: [
        {
            title: "Cactus Interviews",
            description: "Tool for drafting reusable interview scripts with LLM support and taking notes during interviews. Built to streamline the interview process for interviewers.",
            link: "https://cactus-interviews.com",
            logo: cactusInterviewsLogo,
            year: 2024,
            type: ProjectTypes.WebApp,
            technologies: ["React (TypeScript)", "Firebase", "LLMs (Gemini)", "TailwindCSS"],
            media: {
                items: [cactusInterviewsScreenshot1, cactusInterviewsScreenshot2, cactusInterviewsScreenshot3, cactusInterviewsScreenshot4],
                display: "landscape",
            },
        },
        {
            title: "Carimbo",
            description: "Web app and service to make links to your app stand out by adding dynamic open graph preview images. No infrastructure, custom code or API calls needed. Just set up a template layout in HTML and carimbo does the rest.",
            link: "https://carimbo.dev",
            logo: carimboLogo,
            year: 2023,
            type: ProjectTypes.WebApp,
            technologies: ["React (TypeScript)", "Fly.io", "Express", "Puppeteer", "Firebase"],
            media: {
                items: [carimboScreenshot1, carimboScreenshot2, carimboScreenshot3, carimboScreenshot4],
                display: "landscape",
            },
        },
        {
            title: "Lumina",
            description: "Social network to bring friends closer together using micro-events and photo sharing based on geolocation. Featuring native frontends on android and iOS and a custom backend hosted in the cloud.",
            link: "https://lumina-app.com",
            logo: luminaLogo,
            year: 2020,
            type: ProjectTypes.MobileApp,
            discontinued: true,
            cta: "Open Website",
            technologies: ["iOS (Swift)", "Android (Kotlin)", "Firebase", "Kotlin", "Ktor", "PostgreSQL", "Docker", "OpenStreetMap"],
            highlight: "Signed up 500 users in the first 3 months before pausing the project due to COVID-19. Over 300 events created via Lumina.",
            media: {
                items: [luminaScreenshot1, luminaScreenshot2, luminaScreenshot3, luminaScreenshot4],
                display: "portrait",
            }
        },
        {
            title: "bruder-architekten.de",
            description: "A website for my father's architecture studio. Built with React and Contentful to allow easy updating of projects and team members.",
            link: "https://bruder-architekten.de",
            year: 2019,
            type: ProjectTypes.Website,
            technologies: ["React (TypeScript)", "Contentful", "Gatsby", "Netlify"],
            media: {
                items: [bruderArchitektenScreenshot1, bruderArchitektenScreenshot2, bruderArchitektenScreenshot3, bruderArchitektenScreenshot4],
                display: "landscape",
            },
        },
        {
            title: "Hourz",
            description: "A simple android app for tracking working time by the hour for multiple jobs. Supports tracking of specific tasks to generate PDF invoices or Excel exports and sports a simple set of location-based rules for automated tracking.",
            cta: "Open Website",
            link: "https://hourz.app",
            logo: hourzLogo,
            year: 2016,
            type: ProjectTypes.MobileApp,
            discontinued: true,
            technologies: ["Android (Kotlin)", "Couchbase NoSQL", "AWS Lambda", "AWS DynamoDB"],
            media: {
                items: [hourzScreenshot1, hourzScreenshot2, hourzScreenshot3, hourzScreenshot4],
                display: "portrait",
            }
        },
        {
            title: "Wöhlerschule App",
            description: "Customizable substitution plan browser and school planner I built for my high-school. Backed by a custom PHP web crawler with a MySQL database that sends substitution plan updates via Google Cloud Messaging.",
            logo: woehlerschuleLogo,
            year: 2013,
            type: ProjectTypes.MobileApp,
            discontinued: true,
            technologies: ["Android (Java)", "PHP", "MySQL", "GCM"],
            media: {
                items: [woehlerschuleScreenshot1, woehlerschuleScreenshot2, woehlerschuleScreenshot3, woehlerschuleScreenshot4],
                display: "portrait",
            },
        }
    ],
    certifications: [
        {
            title: "Apple WWDC 2018 Scholarship",
            description: "I was one of 350 students and young professionals worldwide to receive a scholarship to attend Apple's Worldwide Developers Conference (WWDC) in San Jose, CA. Selected based on a submitted Swift playground project demonstrating creativity and technical skills.",
            logo: {
                light: appleLogoLight,
                dark: appleLogoDark,
            },
            media: {
                items: [wwdcPicture1, wwdcPicture2, wwdcPicture3],
                display: "portrait",
            },
            links: [
                {
                    label: "Spiegel Online Coverage (feat. me)",
                    url: "https://www.spiegel.de/netzwelt/gadgets/apple-wwdc-2018-sag-auf-einer-party-nie-dass-du-was-mit-computern-machst-a-1210593.html"
                },
                {
                    label: "BILD Coverage (feat. me)",
                    url: "https://www.bild.de/digital/multimedia/apple-wwdc/junge-entwickler-bei-apples-wwdc-55929468.bild.html"
                }
            ]
        },
        {
            title: "GMAT",
            priority: "low",
            description: "Graduate Management Admission Test",
            logo: {
                light: gmatLogoLight,
                dark: gmatLogoDark,
            },
            logoFrame: true,
            score: {
                value: "760",
                maxScore: "800",
                percentile: "99th"
            },
        },
        {
            title: "TOEFL",
            priority: "low",
            description: "Test of English as a Foreign Language",
            logo: toeflLogo,
            logoFrame: true,
            score: {
                value: "112",
                maxScore: "120",
            },
        },
        {
            title: "AWS Certified Solutions Architect (Associate)",
            priority: "low",
            logo: awsLogo,
            links: [
                {
                    label: "Credential",
                    url: "https://www.credly.com/badges/66ebe0fa-d998-4b85-94b6-e1778ef37af3/public_url",
                },
            ]
        },
        {
            title: "Web Summit Scholarship 2022",
            priority: "low",
            logo: {
                light: webSummitLogoLight,
                dark: webSummitLogoDark,
            },
            description: "Awarded a scholarship to attend Web Summit 2022 in Lisbon, Portugal.",
        }
    ]
};